import { render, staticRenderFns } from "./FourPanelPage.vue?vue&type=template&id=5db51824&scoped=true&"
import script from "./FourPanelPage.vue?vue&type=script&lang=js&"
export * from "./FourPanelPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db51824",
  null
  
)

export default component.exports